<template>
  <div style="float: right;">
    <template v-for="(lang, key) in langs"><span :key="lang.flags" style="width: 20px; cursor: pointer;" class="flag-icon" :class="flags(lang.flags)" @click="setLang(key)"></span></template>
  </div>
</template>

<script>
import 'flag-icon-css/css/flag-icon.css';

import { SetLang, GetLang, LangStatus } from '@/f1/service/i18n'
export default {
  data: () => ({ langs : [] }),
  methods: {
    setLang(lang) { SetLang(lang); },
    flags(lang) { return `flag-icon-${lang.toLowerCase()}`; }
  },
  mounted() {
    this.langs = GetLang();
    this.LangStatus = LangStatus()
  },
};
</script>
